export const Logo = ({ className = "h-7 w-7", withWordmark = false, testId = "logo" }) => (
  <span data-testid={testId} className="flex items-center gap-2.5">
    <svg
      viewBox="0 0 40 40"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Jamila logo"
    >
      {/* ticket / speech-bubble outline with notched corner */}
      <path
        d="M5 5H31L35 9V29H14L6 35V29H5V5Z"
        stroke="hsl(var(--primary))"
        strokeWidth="2.5"
        strokeLinejoin="miter"
      />
      {/* letter J */}
      <path
        d="M24 11H27V22.5C27 25.9 24.6 28 21.4 28C18.9 28 16.9 26.8 16 24.8L18.7 23.3C19.2 24.3 20.1 24.9 21.2 24.9C22.8 24.9 24 23.9 24 22.1V11Z"
        fill="hsl(var(--primary))"
      />
      <rect x="20" y="11" width="7" height="3" fill="hsl(var(--primary))" />
    </svg>
    {withWordmark && (
      <span className="flex flex-col leading-none">
        <span className="font-display text-lg font-black tracking-tight text-white">Jamila</span>
        <span className="mt-0.5 font-mono text-[8px] uppercase tracking-[0.28em] text-neutral-500">
          Ticket System
        </span>
      </span>
    )}
  </span>
);
